// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-templates-location-js": () => import("/opt/build/repo/src/templates/location.js" /* webpackChunkName: "component---src-templates-location-js" */),
  "component---src-pages-404-js": () => import("/opt/build/repo/src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-index-js": () => import("/opt/build/repo/src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */)
}

